export var isNotEmptyString = function isNotEmptyString(value) {
  return typeof value === 'string' && value !== '';
};